/**
 * Chat UI Constants
 * Timing, limits, and configuration values for the chat interface
 */

// ============================================================================
// Timing Constants
// ============================================================================

export const TIMING = {
    /** Delay before auto-scrolling to new messages (ms) */
    AUTO_SCROLL_DELAY: 100,
    /** Debounce time for scroll events (ms) */
    SCROLL_DEBOUNCE: 150,
    /** Typing indicator animation interval (ms) */
    TYPING_INDICATOR_INTERVAL: 400,
    /** Delay before showing "still thinking" message (ms) */
    THINKING_THRESHOLD: 5000
};

// ============================================================================
// WebSocket Configuration
// ============================================================================

export const WEBSOCKET_CONFIG = {
    /** Maximum reconnection attempts */
    MAX_RECONNECT_ATTEMPTS: 5,
    /** Base delay for reconnection (ms) - uses exponential backoff */
    RECONNECT_BASE_DELAY: 1000,
    /** Maximum reconnection delay (ms) */
    MAX_RECONNECT_DELAY: 30000,
    /** WebSocket endpoint path */
    ENDPOINT_PATH: '/ws/chat',
    /** HTTP fallback endpoint path */
    HTTP_ENDPOINT_PATH: '/chat',
    /** Ping interval to keep connection alive (ms) */
    PING_INTERVAL: 30000,
    /** Development backend URL - set to null to use same origin */
    DEV_BASE_URL: 'localhost:3000'
};

// ============================================================================
// Message Limits
// ============================================================================

export const MESSAGE_LIMITS = {
    /** Maximum characters in a single user message */
    MAX_MESSAGE_LENGTH: 10000,
    /** Maximum messages to keep in history */
    MAX_HISTORY_LENGTH: 100
};

// ============================================================================
// UI Configuration
// ============================================================================

export const UI_CONFIG = {
    /** Enable auto-scroll when new messages arrive */
    AUTO_SCROLL_ENABLED: true,
    /** Scroll threshold to consider "at bottom" (px) */
    SCROLL_BOTTOM_THRESHOLD: 100,
    /** Show timestamp on every message vs grouped */
    SHOW_ALL_TIMESTAMPS: false,
    /** Group messages within this time window (ms) */
    MESSAGE_GROUP_THRESHOLD: 60000
};

// ============================================================================
// Streaming State
// ============================================================================

export const STREAMING_STATE = {
    /** No active streaming */
    IDLE: 'idle',
    /** Waiting for response to start */
    PENDING: 'pending',
    /** Actively receiving content */
    STREAMING: 'streaming',
    /** Stream completed */
    COMPLETE: 'complete',
    /** Stream error */
    ERROR: 'error'
};

// ============================================================================
// Agent Modes
// ============================================================================

export const AGENT_MODES = {
    /** Agent will discuss and provide information */
    DISCUSS: 'discuss',
    /** Agent will take actions */
    ACT: 'act'
};

// ============================================================================
// Local Storage Keys
// ============================================================================

export const STORAGE_KEYS = {
    /** Conversation history */
    CONVERSATION_HISTORY: 'ai_assistant_history',
    /** User preferences */
    USER_PREFERENCES: 'ai_assistant_preferences',
    /** Auth token */
    AUTH_TOKEN: 'auth_token'
};
